import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { getFormAction } from "../../Actions/FormAction/FormAction";

import { getVisitAction } from "../../Actions/VisitAction/VisitAction";
import { useNavigate, useParams } from "react-router-dom";
import VisitiProfile from "../../Pages/Patient/EachVisit/VisitiProfile";
import ProfilePatient from "../../Pages/Patient/EachVisit/ProfilePatient";
import { IoMdArrowRoundBack } from "react-icons/io";
import LoadingPage from "../../Pages/Loading/LoadingPage";

const MedicalForm = () => {
  const { id: patient_id } = useParams();
  const dispatch = useDispatch();
  const getForm = useSelector((state) => state.getForm);
  const { forms } = getForm;
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getFormAction([1]));
    dispatch(getVisitAction(patient_id));
  }, []);
  const [activeTab, setActiveTab] = useState(0);
  const getVisit = useSelector((state) => state.getVisit);
  const { visits, loading } = getVisit;
  const tabs = [
    {
      title: "Profile",
      content: <ProfilePatient />,
    },
    ...visits.map((visit) => ({
      title: visit.created_at.split("T")[0],
      content: (
        <VisitiProfile
          key={visit.id}
          visit={visit}
          setActiveTab={setActiveTab}
          followUp={visit.follow_up_commite}
          forms={forms}
        />
      ),
    })),
  ];
  useEffect(() => {
    setActiveTab(0);
  }, []);

  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <React.Fragment>
          <button
            onClick={() => navigate(-1)}
            className="btn-danger rounded-sm flex gap-2 items-center ml-5 mt-2"
          >
            <IoMdArrowRoundBack /> Back
          </button>
          <div className=" mt-4 px-2 flex flex-col lg:flex lg:flex-row gap-4 m-auto bg-white  rounded-sm shadow-lg w-[97%]">
            <div className="lg:w-2/12 w-11/12 m-auto  lg:ml-4 mt-4">
              <div className="bg-gray-100 rounded-md">
                <div className="flex flex-col items-center ">
                  {tabs.map((tab, index) => (
                    <button
                      key={index}
                      className={` py-2 rounded focus:outline-none ${
                        activeTab === index
                          ? "bg-slate-800 w-full text-white"
                          : "bg-gray-200 w-full text-gray-700"
                      }`}
                      onClick={() => setActiveTab(index)}
                    >
                      {tab.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="w-full">{tabs[activeTab].content}</div>
          </div>{" "}
        </React.Fragment>
      )}
    </>
  );
};

export default MedicalForm;
